<style scoped lang="sass">
#menu-inner
  padding: 0.7rem
  ul
    list-style-type: square
    li
      color: white
      margin-bottom: 0.75rem
      a
        color: white
</style>
<template>
  <left-side-tray :handle-close="cancel">
    <div id="menu-inner">
      <router-link :to="{name: 'newPool'}" @click.native="handleClose" class="button positive">Start a New Pool</router-link>
      <ul>
        <li>
          <a href="#" @click.prevent="goTo({name: 'account'})">Account</a>
        </li>
        <li>
          <a href="#" @click.prevent="goTo({name: 'dashboard'})">Dashboard</a>
        </li>
        <li>
          <a href="#" @click.prevent="goTo({name: 'faq'})">FAQ</a>
        </li>
        <li>
          <a href="#" @click.prevent="goTo({name: 'contact'})">Contact Us</a>
        </li>
        <li v-if="$root.currentUser.admin">
          <a href="#" @click.prevent="goTo({name: 'admin'})">Admin</a>
        </li>
        <li>
          <a href="#" @click.prevent="logOut">Logout</a>
        </li>
      </ul>
    </div>
  </left-side-tray>
</template>
<script>
import LeftSideTray from './left-side-tray.vue';

export default {
  name: 'LeftSideMenu',
  props: {
    handleClose: {
      type: Function,
      required: true
    }
  },
  components: {
    LeftSideTray
  },
  data: function() {
    return {
      originalConfig: Object.assign({}, this.$store.state.navigation),
      restoreNav:     false
    };
  },
  created: function() {
    this.$store.dispatch('configNavigation', {leftEnabled: true, leftImg: 'icon-close.svg'});
  },
  destroyed: function() {
    if (this.restoreNav) {
      this.$store.dispatch('configNavigation', this.originalConfig);
    }
  },
  computed: {
    participations: function() {
      return this.$store.state.participationsAwaitingUser;
    }
  },
  methods: {
    cancel() {
      this.restoreNav = true;
      this.handleClose();
    },
    logOut() {
      this.$store.dispatch('logOut');
      this.$store.dispatch('messages/setMessage', {key: 'loginMessage', message: 'Logged out'});
      this.goTo({name: 'login'});
    },
    goTo(route) {
      this.handleClose();
      this.$router.push(route);
    }
  }
}
</script>
